export default "__VITE_ASSET__C2Gqj9AA__"